import {useEffect} from 'react';

// PostHog "Notification bar" site app, injected outside the app.
export const BAR = '.notification-bar';
export const CONTAINER = '.notification-bar-container';

export const EXTERNAL_BANNER_HOST = 'BannerStackHost';

export const externalBannerOffset = 'var(--external-banner-offset, 0px)';
export const externalBannerHeight = 'var(--external-banner-height, 0px)';

const useBarMeasurement = (property) => {
  useEffect(() => {
    let current = null;
    let observed = null;
    let sizeObserver = null;

    const measure = () => {
      const bar = document.querySelector(BAR);

      if (sizeObserver && bar !== observed) {
        if (observed) sizeObserver.unobserve(observed);
        if (bar) sizeObserver.observe(bar);
        observed = bar;
      }

      const value = bar
        ? Math.max(0, Math.floor(bar.getBoundingClientRect().height))
        : 0;

      if (value === current) return;
      current = value;
      document.body.style.setProperty(property, `${value}px`);
    };

    if (typeof ResizeObserver !== 'undefined') {
      sizeObserver = new ResizeObserver(measure);
    }

    measure();

    const domObserver = new MutationObserver(measure);
    domObserver.observe(document.body, {childList: true});
    window.addEventListener('resize', measure);

    return () => {
      domObserver.disconnect();
      if (sizeObserver) sizeObserver.disconnect();
      window.removeEventListener('resize', measure);
      document.body.style.removeProperty(property);
    };
  }, [property]);
};

export const useExternalBannerOffset = () =>
  useBarMeasurement('--external-banner-offset');

export const useExternalBannerHeight = () =>
  useBarMeasurement('--external-banner-height');
